export default __webpack_public_path__ + "static/media/Allocate-documentation.d737cc45.md";